import axios from 'axios'
import {ResponseObjectPaginated} from '../../../../../models'
import {TermsModel, GetPaginationTermsDto} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export function getTermsService(dto: GetPaginationTermsDto) {
  return axios.post<ResponseObjectPaginated<TermsModel[]>>(`${BASEURL}/terms/getList`, dto)
}
